module.exports = __webpack_public_path__ + "img/complete.26c91e22.svg";